import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IQueryLine } from 'app_sasha/shared/interfaces/IDefaultSearchParametersHomeConfig';
import { Params, Router } from '@angular/router';
import { BookingSearchParameters } from 'app_sasha/shared/models/BookingSearchParameters';
import { PopupMenuPermissionService } from 'app_sasha/shared/services/popup-menu-permission/popup-menu-permission.service';
import { IMenuItem, IPopupMenuConfig } from 'libraries/component/popup-menu/popup-menu.component';
import { IBookingSearchParametersURL } from 'libraries/interfaces/IBookingSearchParameters';
import { DatesService } from "app_sasha/shared/services/dates/dates.service";
import { ProcessingType, PROCESSING_WORDING } from "libraries/service/processing/processing.service";

@Component({
    selector: 'saved-search',
    template: `
        <a [routerLink]="['/sasha/booking/search-result']"
           [queryParams]="url"
           class="col-to-row-s-tb flex-1 e2e-indicators-bookings">
            <booking-summary-badge
                    [title]="configuration.title | localized"
                    [query]="query"
                    (onTotalOfBookings)="totalOfBookings($event)">
            </booking-summary-badge>
            {{ configuration.title | localized }}
        </a>
        <popup-menu *ngIf="!disabledActions"
                    [menuConfig]="processingMenuConfig"
                    [disabled]="disabledActions"
                    (onSelect)="selectProcessing($event, configuration.queryString)"></popup-menu>
    `,
    styles: [`
        a {
            margin-top: 5px;
            margin-bottom: 5px;
            text-decoration: none;
        }

        :host {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    `]
})
export class SavedSearchComponent implements OnChanges, OnInit {
    @Input()
    public configuration: IQueryLine;

    @Output()
    public readonly onSelectProcessing: EventEmitter<{ processingName: string; params: BookingSearchParameters }> = new EventEmitter();

    public query: BookingSearchParameters;
    public url: { [key: string]: unknown };
    public disabledActions: boolean = true;

    public processingMenuConfig: IPopupMenuConfig = {
        buttonLabel: PROCESSING_WORDING.buttonLabel,
        items: [],
    };

    public constructor(
        private readonly router: Router,
        private readonly popupMenuPermissionService: PopupMenuPermissionService,
        private readonly datesService: DatesService,
    ) {
    }

    public ngOnInit(): void {
        const permissions: Array<{ processing: ProcessingType; permission: string }> = [
            {permission: 'sasha.processing.email.use', processing: ProcessingType.SendEmail},
            {permission: 'sasha.processing.sms.use', processing: ProcessingType.SendSms},
            {permission: 'sasha.processing.qualityCheck.use', processing: ProcessingType.QualityCheck},
            {permission: 'sasha.processing.issue.use', processing: ProcessingType.Issue},
            {permission: 'sasha.processing.cancel.use', processing: ProcessingType.Cancel},
            {permission: 'sasha.processing.void.use', processing: ProcessingType.Void}
        ];

        this.popupMenuPermissionService.getMenuItem(permissions).subscribe(
            (items: IMenuItem[]) => {
                this.processingMenuConfig = {
                    buttonLabel: PROCESSING_WORDING.buttonLabel,
                    items
                };
            }
        );
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.query = this.parseParams(this.configuration.queryString);
        this.url = this.getUrlQuery(this.configuration);
    }

    public selectProcessing(processingName: string, params: string): void {
        const parsedParams: BookingSearchParameters = this.parseParams(params);
        parsedParams.nbrecord = 1000;

        this.onSelectProcessing.emit({
            processingName,
            params: parsedParams
        });
    }

    public totalOfBookings({title, total}: { title: string; total: number }): void {
        this.disabledActions = !total || total > 1000;
    }

    private getUrlQuery(params: IQueryLine): Params {
        return this.router.parseUrl(params.queryString).queryParams;
    }

    private parseParams(params: string): BookingSearchParameters {
        const queryParams: Params = this.router.parseUrl(params).queryParams;
        // #TODO Vérifier si on ne peut pas faire autrement
        return BookingSearchParameters.fromRouteParams(queryParams as IBookingSearchParametersURL, this.datesService);
    }
}
